import script from "./theme-buttons.vue?vue&type=script&lang=js"
export * from "./theme-buttons.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__